// src/routes/AppRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import ModuleRoute from './ModuleRoute';
import Layout from './Layout';
import { MODULES } from '../config/tenantPermissions';

// Authentication related pages
import Login from '../pages/Login/Login';
import PersonaRegistrar from '../pages/Login/PersonaRegistrar';
import UsuariosRegistros from '../pages/Login/UsuariosRegistros';
import MiContrato from '../pages/Portal/MiContrato';
import MisPagos from '../pages/Portal/MisPagos';
import Perfil from '../pages/Login/Perfil';
import EditarPerfil from '../pages/Login/EditarPerfil';
import ConfiguracionCambioContrasena from '../pages/Login/ConfiguracionCambioContrasena';
import CuentaConfiguracion from '../pages/Login/CuentaConfiguracion';

// Dashboard
import AdminDashboard from '../pages/Dashboard/AdminDashboard';

// Inmuebles
import AnadirInmueble from '../pages/Inmueble/AnadirInmueble';
import InmuebleRegistros from '../pages/Inmueble/InmuebleRegistros';
import VerInmueble from '../pages/Inmueble/VerInmueble';
import EditarInmueble from '../pages/Inmueble/EditarInmueble';

// Espacios
import EspaciosRegistrar from '../pages/Espacios/EspaciosRegistrar';
import EspaciosRegistros from '../pages/Espacios/EspaciosRegistros';

// Reportes
import ReporteGastos from '../pages/Reportes/ReporteGastos';
import ReportePagos from '../pages/Reportes/ReportePagos';

// Contratos
import ContratoGenerar from '../pages/Contratos/ContratoGenerar';
import ContratoRegistros from '../pages/Contratos/ContratoRegistros';

// Inquilinos
import InquilinosRegistros from '../pages/Inquilinos/InquilinosRegistros';
import InquilinosRegistrar from '../pages/Inquilinos/InquilinosRegistrar';
import InquilinosPago from '../pages/Inquilinos/InquilinosPago';

// Contabilidad
import PagosCrud from '../pages/Contabilidad/PagosCrud';
import PagosRegistrar from '../pages/Contabilidad/PagosRegistrar';
import GastosCrud from '../pages/Contabilidad/GastosCrud';
import GastosRegistrar from '../pages/Contabilidad/GastosRegistrar';
import ContabilidadGastos from '../pages/Contabilidad/ContabilidadGastos';
import ContabilidadPagos from '../pages/Contabilidad/ContabilidadPagos';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
          <Route element={<ModuleRoute module={MODULES.DASHBOARD} />}>
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.CONFIGURACION} />}>
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/editar-perfil" element={<EditarPerfil />} />
            <Route path="/conf-cambio-contrasena" element={<ConfiguracionCambioContrasena />} />
            <Route path="/cuenta-configuracion" element={<CuentaConfiguracion />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.MI_CONTRATO} />}>
            <Route path="/mi-contrato" element={<MiContrato />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.MIS_PAGOS} />}>
            <Route path="/mis-pagos" element={<MisPagos />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.USUARIOS} />}>
            <Route path="/persona-registrar" element={<PersonaRegistrar />} />
            <Route path="/usuarios-registros" element={<UsuariosRegistros />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.INMUEBLES} />}>
            <Route path="/inmueble-anadir" element={<AnadirInmueble />} />
            <Route path="/inmueble-registros" element={<InmuebleRegistros />} />
            <Route path="/inmuebles/ver/:id" element={<VerInmueble />} />
            <Route path="/inmuebles/editar/:id" element={<EditarInmueble />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.ESPACIOS} />}>
            <Route path="/espacios-anadir" element={<EspaciosRegistrar />} />
            <Route path="/espacios-registrar" element={<EspaciosRegistrar />} />
            <Route path="/espacios-registros" element={<EspaciosRegistros />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.REPORTES} />}>
            <Route path="/reporte-pagos" element={<ReportePagos />} />
            <Route path="/reporte-gastos" element={<ReporteGastos />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.CONTRATOS} />}>
            <Route path="/contrato-generar" element={<ContratoGenerar />} />
            <Route path="/contrato-registros" element={<ContratoRegistros />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.INQUILINOS} />}>
            <Route path="/inquilinos-registros" element={<InquilinosRegistros />} />
            <Route path="/inquilinos-registrar" element={<InquilinosRegistrar />} />
            <Route path="/inquilinos-pago" element={<InquilinosPago />} />
          </Route>

          <Route element={<ModuleRoute module={MODULES.CONTABILIDAD} />}>
            <Route path="/contabilidad-pagos" element={<ContabilidadPagos />} />
            <Route path="/contabilidad-gastos" element={<ContabilidadGastos />} />
            <Route path="/pagos-crud" element={<PagosCrud />} />
            <Route path="/pagos-registrar" element={<PagosRegistrar />} />
            <Route path="/gastos-crud" element={<GastosCrud />} />
            <Route path="/gastos-registrar" element={<GastosRegistrar />} />
          </Route>
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
